import React from "react"
import {CountdownTimer2} from "../../../../../components/CountdownTimer"
import "./BreakInfoPage.css"

interface Props {
    userInfo: any
    durationInSeconds: number
    onNext: () => void
}

export default function BreakInfoPage(props: Props) {
    let {userInfo, durationInSeconds, onNext} = props
    let {firstName, lastName} = userInfo
    let fullName = `${firstName} ${lastName}`
    let active = true

    let timerId = setTimeout(() => {
        if (active && onNext) {
            onNext()
        }
    }, durationInSeconds*1000)

    function handleResumeTesting() {
        active = false
        clearTimeout(timerId)

        if (onNext) {
            onNext()
        }
    }

    return (
        <div className="break-info-container justify-content-xl-center align-items-center">
            <div className="container m-auto">
                <div className="row">
                    <div className="col-md-5 col-xl-6 mb-4 mb-md-0">
                        <div className="countdown-info-container flex-column align-items-center justify-content-xl-center d-flex h-100">
                            <div className="countdown-info">
                                <div className="remaining-break-time">
                                    Remaining Break Time:
                                    <div className="countdown">
                                        <CountdownTimer2 fromInSeconds={durationInSeconds}/>
                                    </div>
                                </div>
                                <button onClick={handleResumeTesting}>Resume Testing</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7 col-xl-6">
                        <div className="instructions-container flex-column justify-content-center d-flex h-100">
                            <h1 className="instructions-container--title">Practice Test Break</h1>
                            <p>You can resume this practice test as soon as you're ready to move on. On test day, you'll wait until the clock counts down. Read below to see how breaks work on test day.</p>
                            <hr className="white my-4" />
                            <h2 className="instructions-container--title">Take a Break: Do Not Close Your Device</h2>
                            <p>After the break, your test will <b>automatically start the next section</b>. Make sure you're back at your desk and ready.</p>
                            <p>
                                <b>Follow these rules during the break:</b><br/>
                                <ol>
                                    <li>Do not disturb students who are still testing.</li>
                                    <li>Do not exit the app or close your laptop.</li>
                                    <li>Do not access phones, smartwatches, textbooks, notes, or the internet.</li>
                                    <li>Do not eat or drink near any testing device.</li>
                                    <li>Do not speak in the testing room; outside the room, do not discuss the exam with anyone.</li>
                                </ol>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="user-name">
                {fullName}
            </div>
        </div>
    )
}
